import { ErrorsService } from "./../../../../services/common/errors.service";
import { TranslateService } from "@ngstack/translate";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange
} from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";

import { SoundEnum } from "src/app/enums/sound.enum";
import { IAgeGroup } from "src/app/interfaces/ageGroup";
import { IPublicPackage } from "src/app/interfaces/publicPackage";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { SnackBarService } from "./../../../../services/common/snackBar.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { PackagePublicService } from "./../../../../services/http/business/packagePublic/package-public.service";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-package-entry",
  templateUrl: "./add-package-entry.component.html",
  styleUrls: ["./add-package-entry.component.css"],
  providers: [ErrorsService]
})
export class AddPackageEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  imgURL: any;
  errObject: any;
  form: FormGroup;
  url = environment.BaaseUrl;
  fileName: string;
  isOwner: boolean;
  companyCode: string;
  errors = new Array();
  companyList: ICompany;
  fielExtension: string;
  groupAgeList: IAgeGroup;
  base64textString: string;
  editPackageId: boolean = true;
  publicPackageList: IPublicPackage;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private staticValueService: StaticValueService,
    private publicPackageService: PackagePublicService,
    private educationPackageService: EducationPackageService,
    public dialogRef: MatDialogRef<AddPackageEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: IEducationPackage
  ) {
    if (this.data) {
      this.imgURL = this.url + "/" + this.data.FileAddress;
      this.fileName = this.data.FileDisplayName;
      this.editPackageId = false;
    }
  }

  ngOnInit() {
    this.createForm();
    this.checkOwner();
    this.getGroupAge();
    this.getPublicPackage();
  }

  createForm() {
    this.form = this.fb.group({

      FileDisplayName: [
        this.data && this.data.FileDisplayName
          ? this.data.FileDisplayName
          : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(3)
        ])
      ],
      ImageData: [
        this.data && this.data.ImageData ? this.data.ImageData : null
      ],
      GroupAgeId: [
        this.data && this.data.GroupAgeId
          ? this.data.GroupAgeId.toString()
          : null,
        Validators.compose([Validators.required])
      ],
      PublicPackageId: [1,
        Validators.compose([Validators.required])
      ],
      Description: [
        this.data && this.data.Description
          ? this.data && this.data.Description
          : null,
        Validators.compose([Validators.required, Validators.maxLength(100)])
      ],
      PackageName: [""],
      Id: [this.data && this.data.Id ? this.data.Id : 0]
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  onFileChange(event) {
    var files = event.target.files;
    var file = files[0];
    if (files && file) {
      if (file.size <= 100000) {
        this.fileName = file.name;
        this.form.patchValue({
          FileDisplayName: file.name
        });
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("require.fileUpload", {
            size: "100kb"
          }),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    }
  }

  _handleReaderLoaded(readerEvt) {
    this.imgURL = "data:image/png;base64," + btoa(readerEvt.target.result);
    this.form.patchValue({
      ImageData: btoa(readerEvt.target.result)
    });
  }

  getGroupAge() {
    this.staticValueService.ageCategory(false).subscribe(
      res => {
        this.groupAgeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getPublicPackage() {
    this.publicPackageService.list().subscribe(
      res => {
        this.publicPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setCompanyCode(e: MatSelectChange) {
    this.companyCode = e.value;
    this.cidService.setCID(e.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(form: IEducationPackage) {
    this.errors = new Array();
    if (this.data && this.data.FileDisplayName) {
      this.educationPackageService.edit(form).subscribe(
        () => {
          this.dialogRef.close();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.educationPackageService.add(form).subscribe(
        () => {
          this.dialogRef.close();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }
}
